import { DocxParserEnum } from "../types";
export var getDocumentFileInfo = function(type) {
    var docxParser = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DocxParserEnum.Libre;
    var map = {
        docx: {
            ext: "docx",
            mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            parser: docxParser === DocxParserEnum.Libre ? "docx:libreoffice" : "docx"
        },
        pdf: {
            ext: "pdf",
            mime: "application/pdf",
            parser: "pdf"
        }
    };
    return map[type] || null;
};
